import { Link } from "react-router-dom";
import { NAV_LINKS, CONTACT, scrollToId } from "@/lib/site";
import { useLang } from "@/lib/i18n";
import Logo3D from "@/components/Logo3D";
import { Phone, Mail, Clock } from "lucide-react";

export default function Footer() {
  const { t } = useLang();
  const go = (href) => scrollToId(href);

  const navItems = [
    { label: t.nav.whatWeDo, href: "#what-we-do", key: "what-we-do" },
    { label: t.nav.pricing, href: "#pricing", key: "pricing" },
    { label: t.nav.process, href: "#process", key: "process" },
    { label: t.nav.contact, href: "#contact", key: "contact" },
  ];

  return (
    <footer data-testid="site-footer" className="border-t border-border bg-background">
      <div className="mx-auto max-w-7xl px-6 md:px-10 py-16">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <Logo3D imgClass="h-28 w-auto" wrapperClass="mb-6" />
            <p className="text-muted-foreground max-w-sm leading-relaxed">
              {t.footer.tagline}
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="font-mono-x text-xs uppercase tracking-[0.2em] text-muted-foreground mb-5">{t.footer.explore}</p>
            <ul className="space-y-3">
              {navItems.map((l) => (
                <li key={l.href}>
                  <button
                    onClick={() => go(l.href)}
                    data-testid={`footer-nav-${l.key}`}
                    className="text-foreground/80 hover:text-primary transition-colors"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="font-mono-x text-xs uppercase tracking-[0.2em] text-muted-foreground mb-5">{t.footer.getInTouch}</p>
            <ul className="space-y-3">
              <li>
                <a href={CONTACT.phoneHref} className="flex items-center gap-3 text-foreground/80 hover:text-primary transition-colors" data-testid="footer-phone">
                  <Phone className="h-4 w-4 text-primary" /> {CONTACT.phone}
                </a>
              </li>
              <li>
                <a href={`mailto:${CONTACT.email}`} className="flex items-center gap-3 text-foreground/80 hover:text-primary transition-colors" data-testid="footer-email">
                  <Mail className="h-4 w-4 text-primary" /> {CONTACT.email}
                </a>
              </li>
              <li className="flex items-center gap-3 text-foreground/80">
                <Clock className="h-4 w-4 text-primary" /> {t.footer.hours}
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-border flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-muted-foreground text-center md:text-left">
            © {new Date().getFullYear()} LocalNova Web Design. {t.footer.rights}
          </p>
          <div className="flex items-center gap-5">
            <Link to="/privacy" data-testid="footer-privacy-link" className="text-sm text-muted-foreground hover:text-primary transition-colors">
              {t.footer.privacy}
            </Link>
            <Link to="/terms" data-testid="footer-terms-link" className="text-sm text-muted-foreground hover:text-primary transition-colors">
              {t.footer.terms}
            </Link>
          </div>
          <p className="font-mono-x text-xs uppercase tracking-[0.2em] text-muted-foreground">{t.footer.motto}</p>
        </div>
      </div>
    </footer>
  );
}
